import React from 'react';
import { useController } from 'react-hook-form-v7';
import { TextField, Stack, InputAdornment } from '@mui/material';
import CollapsibleFilterWrapper from '../CollapsibleFilterWrapper';

const onlyDigits = (v) => (typeof v === 'string' ? v.replace(/\D+/g, '') : v);

const CollapsibleNumericRange = ({ control, name, label, adornmentText }) => {
    const { field } = useController({
        control,
        name,
        defaultValue: { from: null, to: null },
    });

    const value = field.value ?? { from: null, to: null };
    const hasAny = value.from !== null || value.to !== null;

    const handleFrom = (e) => {
        const raw = e.target.value;
        const digits = onlyDigits(raw);
        field.onChange({ ...value, from: digits === '' ? null : Number(digits) });
    };

    const handleTo = (e) => {
        const raw = e.target.value;
        const digits = onlyDigits(raw);
        field.onChange({ ...value, to: digits === '' ? null : Number(digits) });
    };

    const onReset = () => field.onChange({ from: null, to: null });

    const adornment =
        typeof adornmentText === 'string' && adornmentText.length > 0
            ? { startAdornment: <InputAdornment position="start">{adornmentText}</InputAdornment> }
            : undefined;

    return (
        <CollapsibleFilterWrapper label={`${label} (${hasAny ? 1 : 0})`} onReset={onReset}>
            <Stack direction="row" spacing={2} sx={{ px: 2, pb: 2 }}>
                <TextField
                    variant="standard" // ⬅️ use standard so label & input start at x=0
                    InputLabelProps={{ shrink: true }} // keep the label up
                    type="text"
                    label="From"
                    value={value.from ?? ''}
                    onChange={handleFrom}
                    InputProps={{
                        disableUnderline: true, // remove underline
                        ...(adornment || {}), // startAdornment: "BKG-"
                        inputProps: { inputMode: 'numeric', pattern: '[0-9]*' },
                    }}
                    fullWidth
                    sx={{
                        // minimal cleanup; no outline classes needed with standard
                        '& .MuiInputAdornment-positionStart': { mr: 0 }, // no extra gap before input
                    }}
                />

                <TextField
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="To"
                    value={value.to ?? ''}
                    onChange={handleTo}
                    InputProps={{
                        disableUnderline: true,
                        ...(adornment || {}),
                        inputProps: { inputMode: 'numeric', pattern: '[0-9]*' },
                    }}
                    fullWidth
                    sx={{ '& .MuiInputAdornment-positionStart': { mr: 0 } }}
                />
            </Stack>
        </CollapsibleFilterWrapper>
    );
};

export default CollapsibleNumericRange;
